import { render, staticRenderFns } from "./JSONViewer.vue?vue&type=template&id=95488fee&scoped=true&"
import script from "./JSONViewer.vue?vue&type=script&lang=js&"
export * from "./JSONViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95488fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDialog,
})
